<template>
  <div class="animated fadeIn targetcollectionform">
    <b-card>
      <div slot="header">
        TDP Requisition - Form
        <!-- <div class="card-header-actions">
          <button :disabled="saveEnabled" class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>-->
      </div>
      <b-row class="justify-content-center">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Refer to CR</label>
            </b-input-group-prepend>
            <b-form-radio-group  v-model="model.istdpcr" class="ml-1 mt-1" >
                <b-form-radio :value="1">Yes (Contact Report)</b-form-radio>
                <b-form-radio :value="0">No (Sales Order)</b-form-radio>
            </b-form-radio-group>
          </b-input-group>
          <b-row>
              <b-col lg="10" xl="8">
                <b-input-group v-if="model.istdpcr==1">
                  <b-input-group-prepend>
                    <label>CR Number</label>
                  </b-input-group-prepend>
                  <b-form-input
                    readonly
                    v-model="model.nomorcr"
                    @keyup.13.native="lkuCrShow=true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-btn text="Button" @click="lkuCrShow=true" variant="primary">
                      <i class="fa fa-search"></i>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
                <b-input-group v-else>
                  <b-input-group-prepend>
                    <label>SO Number</label>
                  </b-input-group-prepend>
                  <b-form-input
                    readonly
                    v-model="model.salesorder"
                    @keyup.13.native="lkuSoShow=true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-btn text="Button" @click="lkuSoShow=true" variant="primary">
                      <i class="fa fa-search"></i>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Cust. Code</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="cust_info"
              @keyup.13.native="lkuKoranCustShow=true"
              :state="!$v.model.customer_id.$error"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranCustShow=true" variant="primary">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Sales Ex.</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.salesae_name"
              @keyup.13.native="lkuSalesShow=true"
              :state="!$v.model.salesae_id.$error"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuSalesShow=true" variant="primary">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Description</label>
            </b-input-group-prepend>
            <b-form-textarea
              id="textarea"
              v-model="model.uraian"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Advertiser</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.Advertiser"
            ></b-form-input>
          </b-input-group>
          <b-row>
              <b-col lg="10" xl="8">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Total Sales</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                  </b-input-group-prepend>
                  <my-number class="form-control text-right"
                    separator=","
                    v-model="model.billing"  disabled
                    :precision="2"
                    :state="!$v.model.billing.$error"
                  ></my-number>
                </b-input-group>
              </b-col>
          </b-row>

          <b-row >
              <b-col cols="5">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>TDP Claim</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.cashbackpc" type="number" :state="!$v.model.cashbackpc.$error"></b-form-input>
                  <b-input-group-append>
                    <span class="input-group-text">
                      <i class="fa fa-percent"></i>
                    </span>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col cols="7">
                <b-input-group>
                  <b-input-group-prepend><span class="p-2">Value</span></b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                  </b-input-group-prepend>
                  <my-number class="form-control text-right"
                    separator=","
                    v-model="model.requestamt"  
                    :precision="2"
                    :state="!$v.model.requestamt.$error"
                  ></my-number>
                </b-input-group>
              </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend><label>TDP Paid To Name</label></b-input-group-prepend>
            <b-form-input v-model="model.paidtoname" placeholder="nama sesuai rekening bank" :state="!$v.model.paidtoname.$error"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>TDP Transfer To</label></b-input-group-prepend>
            <b-form-input v-model="model.paidtobankno" placeholder="No.rekening"></b-form-input>
            <b-form-input v-model="model.paidtobankname" placeholder="Nama bank" class="ml-1"></b-form-input>
          </b-input-group>

        </b-col>
        <b-col lg="6">
            <label>Attachment  <span class="p-2" v-if="(model.attchFileNm)"><b-link @click="attachmentDownload(model)"><i class="fa fa-paperclip"></i> {{ model.attchFileNm }}</b-link></span>   </label>

              <b-form-file class="ml-2"
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>

          <h4 class="mt-4">Progress Sales (on CR)</h4>
          <b-row>
              <b-col lg="10" xl="8">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Sales Commitment</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                  </b-input-group-prepend>
                  <my-number
                    separator=","
                    v-model="model.budget"
                    :precision="2"
                    disabled
                    class="form-control text-right"
                  ></my-number>
                </b-input-group>
              </b-col>
          </b-row>
          <hr />
          <b-row>
              <b-col lg="10" xl="8">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Booked Order</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                  </b-input-group-prepend>
                  <my-number
                    separator=","
                    v-model="model.ordered"
                    :precision="2"
                    disabled
                    class="form-control text-right"
                  ></my-number>
                </b-input-group>
              </b-col>
          </b-row>
          <b-row>
              <b-col lg="10" xl="8">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Compliment</label>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                </b-input-group-prepend>
                <my-number
                  separator=","
                  v-model="model.compliment"
                  :precision="2"
                  disabled
                  class="form-control text-right"
                ></my-number>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <label>Discount</label>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                </b-input-group-prepend>
                <my-number
                  separator=","
                  v-model="model.discount"
                  :precision="2"
                  disabled
                  class="form-control text-right"
                ></my-number>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <label>Saving Value</label>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                </b-input-group-prepend>
                <my-number
                  separator=","
                  v-model="model.saving"
                  :precision="2"
                  disabled
                  class="form-control text-right"
                ></my-number>
              </b-input-group>
              </b-col>
          </b-row>
          <hr />
          <b-row>
              <b-col lg="10" xl="8">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>TDP Claim Accum.</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                  </b-input-group-prepend>
                  <my-number
                    separator=","
                    v-model="model.cashbackpaid"
                    :precision="2"
                    disabled
                    class="form-control text-right"
                  ></my-number>
                </b-input-group>
              </b-col>
          </b-row>

        </b-col>
      </b-row>
      <hr />
      <b-input-group class="justify-content-center mt-1">
        <b-button class="btn btn-success mr-1" @click.stop="save()">Save</b-button>
        <b-button class="btn btn-warning ml-1" @click.stop="cancel()">Cancel</b-button>
      </b-input-group>
    </b-card>

    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranCust"></lku-koran-cust>
    </b-modal>
    <b-modal
      v-model="lkuSalesShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-salesae @click="onSelectsales"></lku-salesae>
    </b-modal>

        <b-modal v-model="lkuCrShow" size="lg" :hide-footer="true" title="TDP Cotact Report "  :centered="true">
            <lku-salestdpcr @click="onSelectLkuCr"></lku-salestdpcr>
        </b-modal>        
        <b-modal v-model="lkuSoShow" size="lg" :hide-footer="true" title="List of Sales Order (Customer P.O)"  :centered="true">
            <lku-salesorder @click="onSelectLkuSo"></lku-salesorder>
        </b-modal>        

  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import tdpreq from "../../apis/salestdprequest";

import { validationMixin } from "vuelidate";
import {
  required,
  decimal,
} from "vuelidate/lib/validators";

import lkuKoranCust from "../lookup/lkuCustomer";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuSalesorder from "../lookup/lkuSalesOrder";
import lkuSalestdpcr from "../lookup/lkuSalesTdpcr";

toastr.init();

export default {
  components: { lkuKoranCust, lkuSalesae, lkuSalestdpcr, lkuSalesorder, myNumber },
  mixins: [validationMixin],
  validations: {
    model: {
      customer_id: { required },
      salesae_id: { required },
      startdate: { required },
      finishdate: { required },
      paidtoname: { required },
      billing: { required },
      cashbackpc: { required },
      requestamt: { decimal },
    }
  },
  data() {
    return {
      saveEnabled: true,
      lkuKoranCustShow: false,
      lkuSalesShow: false,
      lkuSoShow: false,
      lkuCrShow: false,
      showDelConfirm: false,
      file:null,
      model: {
        customer_id: null,
        customer_name: null,
        salesae_id: null,
        salesae_name: null,
        requestdate: null,
        requestamt: 0,
        istdpcr:1,
        budget: 0,
        cashbackpc: 0,
        cashbackval: 0,
        cashbackpaid:0,
        delivered: 0,
        ordered: 0,
        compliment: 0,
        saving: 0,
        uraian: null,
        matauang: this.$store.state.user.matauang
      },
      uanguser: this.$store.state.user.matauang,
      currency: [{ value: "IDR", text: "IDR" }],
      routeAsal: '',
      cust_info: null
    };
  },
  async created() {
    this.routeAsal = localStorage.getItem('tdpReqMenu');;

    if (this.$route.params.tdpreqkey) {
      console.log('this.$route.params: ',this.$route.params);
      const [header] = await tdpreq.detail(this.$route.params);
      this.model = header;
      this.model.startdate = moment(header.startdate).format("YYYY-MM-DD");
      this.model.finishdate = moment(header.finishdate).format("YYYY-MM-DD");
      this.cust_info = `${header.customer_code} | ${header.customer_name}`;
      this.model.salesae_name = `${header.salesae_name}`;
      // lines.map((item, idx) => {
      //   lines[idx].amount = item.budget;
      // });
      // this.packageLine.items = lines;
      this.calculating();
    } else {
      this.model.startdate=moment().startOf('month').format('YYYY-MM-DD')
      this.model.finishdate=moment().endOf('year').format('YYYY-MM-DD')
    }
    
  },

  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch: {
    "model.cashbackpc": function (newval) {
      this.calculating();
    },
    "model.billing": function (newval) {
      this.calculating();
    }
  },
  methods: {
    onSelectKoranCust(_selected) {
      this.cust_info = `${_selected.CustCode + " | " + _selected.CustName}`;
      this.model.customer_id = _selected.customer_id;
      this.model.customer_code = _selected.CustCode;
      this.model.customer_name = _selected.CustName;
      this.lkuKoranCustShow = false;
    },
    onSelectsales(_selected) {
      this.model.salesae_name = `${_selected.crewnik + " | " + _selected.salesae_name}`;
      this.model.salesae_id = _selected.salesae_id;
      this.model.salesae_name = _selected.salesae_name;
      this.lkuSalesShow = false;
    },
    onSelectLkuSo(_selected) {
        this.lkuSoShow=false;
        this.model.tdpcrkey='';
        this.model.salesHdrKey=_selected.salesHdrKey;
        this.model.salesorder = _selected.nomor;        
        this.model.matauang=_selected.matauang;
        this.model.billing=_selected.ttlamtdue;
        this.model.jenisbayar=_selected.jenisbayar;
        this.cust_info = _selected.CustName+ ' | '+ _selected.CustCode;
        this.model.customer_id = _selected.customer_id;
        this.model.customer_name = _selected.CustName;
        this.model.customer_code = _selected.CustCode;
        this.model.Advertiser=_selected.Advertiser;
        this.model.brand=_selected.brand;
        this.model.salesae_name=_selected.SalesEx;
        this.model.salesae_id=_selected.salesae_id || _selected.SalesExCode;

    }, 
    onSelectLkuCr(_selected) {
        this.lkuCrShow=false;
        this.model.salesHdrKey='';
        this.model.salesorder ='';        
        this.model.jenisbayar='';
        this.model.tdpcrkey=_selected.tdpcrkey;
        this.model.nomorcr = _selected.nomor;        
        this.model.matauang=_selected.matauang;
        this.cust_info = _selected.customer_name+ ' | '+ _selected.customer_code;
        this.model.customer_id = _selected.customer_id;
        this.model.customer_name = _selected.customer_name;
        this.model.customer_code = _selected.customer_code;
        this.model.Advertiser=_selected.Advertiser;
        this.model.salesae_name=_selected.salesae_name;
        this.model.salesae_id=_selected.salesae_id;
        this.model.billing=_selected.ordered * ((_selected.cashbackval-_selected.cashbackpaid)/_selected.cashbackval)  ;
        this.model.budget=_selected.budget;
        this.model.ordered=_selected.ordered;
        this.model.delivered=_selected.delivered;
        this.model.discount=_selected.discount;
        this.model.saving=_selected.saving;
        this.model.compliment=_selected.compliment;
        this.model.cashbackpc=_selected.cashbackpc;
        this.model.cashbackpaid=_selected.cashbackpaid;
        this.model.paidtoname=_selected.paidtoname;
        this.model.paidtobankname=_selected.paidtobankname;
        this.model.paidtobankno=_selected.paidtobankno;
        this.model.uraian=_selected.uraian;
        // this.calculating();
    },     
    calculating() {
      // const cashbackpc = this.model.cashbackpc;
      // const budget = this.model.budget;
      // const delivered = this.model.delivered;
      // const ordered = this.model.ordered;
      // const compliment = this.model.compliment;
      // const saving = this.model.saving;
      // const discount = this.model.discount;
      const requestamt = this.model.billing * (parseInt(this.model.cashbackpc,10)/100);
      this.model.requestamt = requestamt;
    },
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            await tdpreq.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },       

    async save() {
      if (this.invalidModel) {
        console.log("validation model : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          const row = new FormData();
          if (this.file){
            row.append('file', this.file);
            row.append('filename', this.file.name);
          }
          for (var key in this.model) {
              row.append(key, this.model[key]);
          }
          row.set('requestdate', this.model.requestdate|| moment().format('YYYY-MM-DD'));
          // row.set('startdate', moment(this.model.startdate).format('YYYY-MM-DD'));
          // row.set('finishdate', moment(this.model.finishdate).format('YYYY-MM-DD'));
          // const lines = this.ordLines.items.reduce((newArr, item) => {
          //     if (((item.itemno || '') != '') && (item.qtyOrder != 0)) {
          //         item.lineno = lineno+1;
          //         item.valueIssued = this.ordLinesObj.invUnitCost * this.ordLinesObj.qtyOrder;
          //         diskonrkp += item.priceDisc;    
          //         newArr.push(item);
          //         lineno += 1;
          //     }
          //     return newArr;
          // }, []);
          // row.set('diskonrkp',diskonrkp);

          await tdpreq.save(row);
          toastr.success("Save successfully");
          router.push({ name: "sales.tdprequest" });
        } catch (error) {
          toastr.error(error, "ERROR MESSAGE");
        }
      }
    },
    cancel() {
      if (this.routeAsal) {
          router.push({name:this.routeAsal});    
      } else {
          router.push({path:"home"});    
      }
        
    }
  }
};
</script>